<template>
  <div class="step-three" @touchend="onBodyTouchEnd">
    <div class="main">
      <div class="icon icon-logo2"></div>
      <p class="sub-title">芒果TV全新声音治愈类真人秀</p>
      <p class="main-title">《朋友请听好》第二季故事招募</p>
      <p class="form-title">
        <span>填写资料</span>
      </p>
      <div class="form">
        <div>
          <div v-for="item of formItems" :key="item.key" class="form-item">
            <div v-if="item.type !== 'question'" class="form-item--inline">
              <div class="form-label">{{ item.label }}</div>
              <div class="input-wrapper">
                <div v-if="item.type === 'date'">
                  <picker
                    date="date"
                    v-model="form[item.key]"
                    :cols="5"
                  ></picker>
                </div>
                <select
                  v-else-if="item.type === 'select'"
                  v-model="form[item.key]"
                >
                  <option disabled value="">请选择</option>
                  <option value="男">男</option>
                  <option value="女">女</option>
                </select>
                <input v-else :type="item.type" v-model="form[item.key]" />
              </div>
            </div>
            <div v-if="item.type === 'question'">
              <div class="form-question">
                {{ item.content }}
              </div>
              <div
                class="ques-wrapper"
                :class="{
                  err: errors[item.key] != null || tmpError[item.key] != null,
                }"
              >
                <textarea
                  v-if="form[item.key].type === 'text'"
                  placeholder="限300字内"
                  v-model="form[item.key].value"
                  rows="5"
                />
                <div v-else class="audio-sec">
                  <div
                    class="icon icon-record1"
                    v-if="form[item.key].recording"
                  ></div>
                  <div v-else-if="form[item.key].audio" class="record2-wrapper">
                    <div
                      class="icon icon-record2"
                      @click="playRecord(form[item.key].audio)"
                    >
                      <span>{{ form[item.key].audio.duration }}</span>
                    </div>
                    <div
                      class="icon icon-del"
                      @click="onDelRecord(item.key)"
                    ></div>
                  </div>
                </div>
                <div class="ques-footer">
                  <div class="err-msg">
                    {{ errors[item.key] || "" }}
                  </div>
                  <div>
                    <span
                      v-if="form[item.key].type === 'text'"
                      class="text-btn"
                      @click="changeMode(form[item.key], 'audio')"
                    >
                      点击切换语音 <span class="icon icon-voice"></span>
                    </span>
                    <template v-else>
                      <span
                        v-if="!form[item.key].audio"
                        class="record-btn"
                        @touchstart="onStartRecord(item.key)"
                        @touchend.stop="onEndRecord(item.key)"
                      >
                        <span
                          class="record-btn-1"
                          v-if="!form[item.key].recording"
                        >
                          按住说话
                        </span>
                        <span v-else class="record-btn-2">
                          <span v-show="form[item.key].showTip"
                            >不能超过60s</span
                          >
                          <span class="icon icon-voice"></span>
                        </span>
                      </span>
                      <span v-else>
                        <span style="color: red" v-show="tmpError[item.key]"
                          >不能超过60s</span
                        >
                        <span class="icon icon-voice"></span>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-tip">
        <p>注意事项</p>
        <p>① 参选者填写的任何个人资料均为节目组所保存及使用；</p>
        <p>② 节目组承诺，此次征集内容保密，绝不外泄；</p>
        <p>③ 请提供可随时直接联络到本人的电话号码，并保证24小时畅通；</p>
        <p>④请保证以上信息的真实性；请精炼语言，填写重点信息。</p>
      </div>
      <div class="btn-normal" @click="onClickSubmit">确认提交</div>
    </div>
  </div>
</template>

<script>
import Recorder from "js-audio-recorder";
import { convertToMp3 } from "@/utils/audio";
import { guid, getQueryValues } from "@/utils/common";
import Player from "./Play";
import OSS from "ali-oss";
import * as Apis from "@/apis";
import Picker from "./picker.vue";
import Env from "@/utils/env";

const getQueInit = () => ({
  type: "text",
  value: "",
  audio: "",
  recording: false,
  showTip: false
});

// const SHARE_CONFIRM_LOG = "mg_friend_record";

function copyText(text) {
  const input = document.createElement("textarea");
  input.innerHTML = text;
  document.body.appendChild(input);
  input.select();
  const result = document.execCommand("copy");
  document.body.removeChild(input);
  return result;
}

export default {
  components: {
    Picker
  },
  data() {
    return {
      recorder: null,
      formItems: [
        { key: "user_name", label: "姓名", type: "text" },
        { key: "gender", label: "性别", type: "select", options: ["男", "女"] },
        { key: "birthday", label: "出生日期", type: "date" },
        { key: "hometown", label: "籍贯", type: "text" },
        { key: "profession", label: "职业", type: "text" },
        { key: "phone", label: "联系方式", type: "tel" },
        {
          key: "answer1",
          type: "question",
          content: "你现在的烦恼和困惑是什么？为什么？"
        },
        {
          key: "answer2",
          type: "question",
          content:
            "你生活中遇到的最温暖、最爆笑、最无奈、最奇葩、最有趣、最想吐糟的……事情是什么？只要是你真实的故事，大声的说出来！"
        },
        {
          key: "answer3",
          type: "question",
          content:
            "你是否经历过非常难忘的成长往事？比如来自家人的、朋友的、陌生人的。"
        },
        {
          key: "answer4",
          type: "question",
          content: "你最想对“广播小站”说的小秘密是什么？"
        }
      ],
      // iOS下，每次pv都会弹窗要求用户授权，用户点击允许的时候，不会触发touchend,因此在ios系统，第一次长按录音作废
      isFirstRecord: true,
      tmpError: {},
      showErr: false,
      submiting: false,
      form: {
        user_name: "",
        gender: "",
        birthday: "2000-01-01",
        hometown: "",
        profession: "",
        phone: "",
        answer1: getQueInit(),
        answer2: getQueInit(),
        answer3: getQueInit(),
        answer4: getQueInit()
      }
    };
  },
  computed: {
    errors() {
      const { form, formItems, showErr } = this;
      return formItems.reduce((obj, item) => {
        if (item.type === "question") {
          const info = form[item.key];
          if (info.type === "text" && info.value.length > 300) {
            obj[item.key] = "限300字内";
          } else if (showErr) {
            if (info.type === "audio" && !_.get(info, "audio.url")) {
              obj[item.key] = "请上传语音";
            }
          }
        }
        return obj;
      }, {});
    },
    submitInfo() {
      const { form, formItems } = this;
      return formItems.reduce((obj, conf) => {
        const { key } = conf;
        const info = form[key];
        if (conf.type === "question") {
          const { audio, type, value } = info;
          obj[key] = {
            type
          };
          if (type === "text") {
            obj[key].value = value;
          } else {
            obj[key].value = audio.url;
          }
        } else {
          obj[key] = form[key];
        }
        return obj;
      }, {});
    }
  },
  methods: {
    onDelRecord(key) {
      this.form[key].type = "text";
      this.form[key].audio = "";
      this.tmpError = {};
    },
    onBodyTouchEnd() {
      console.log("onBodyTouchEnd");
      this.endRecordDelay();
    },
    async uploadFile(data, onSuccess) {
      if (data) {
        const reader = new FileReader();

        reader.onload = async () => {
          const file = new File([reader.result], `${guid()}.mp3`);
          const { url } = await Apis.uploadAudio({ file });
          if (onSuccess) {
            onSuccess(url);
          }
        };

        reader.readAsArrayBuffer(data);
      }
    },
    playRecord(audio) {
      const reader = new FileReader();

      reader.onload = function() {
        Player.play(this.result);
      };

      reader.readAsArrayBuffer(audio.data);
    },
    destroyRecorder() {
      if (this.recorder) {
        this.recorder.destroy().then(function() {});
        this.recorder = null;
      }
    },
    endRecordDelay() {
      if (this.delayTask) {
        clearTimeout(this.delayTask);
        this.delayTask = null;
      }
    },
    onEndRecord(key) {
      console.log("onEndRecord");
      const { recorder, form } = this;
      if (this.delayTask && !recorder) {
        this.$emit("toast", "录音时间过短");
      }
      this.endRecordDelay();
      form[key].recording = false;
      form[key].showTip = false;
      if (recorder) {
        if (recorder.duration < 1) {
          this.$emit("toast", "录音时间过短");
        } else {
          const data = convertToMp3(recorder.getWAV(), recorder);
          this.form[key].audio = {
            url: "",
            data,
            duration: Math.round(recorder.duration)
          };
          this.uploadFile(data, url => (this.form[key].audio.url = url));
        }
        this.destroyRecorder();
      }
    },
    onStartRecord(key) {
      this.endRecordDelay();
      this.destroyRecorder();
      this.delayTask = setTimeout(() => {
        console.log("onStartRecord");
        this.recorder = new Recorder();
        this.recorder.onprogress = params => {
          console.log(params.duration);
          if (params.duration > 3) {
            this.form[key].showTip = false;
          }
          // 时间同步可能有几百毫秒偏差，超过60s
          if (params.duration >= 60) {
            this.onEndRecord(key);
            this.$nextTick(() => {
              this.tmpError = { [key]: true };
              setTimeout(() => {
                this.tmpError = {};
              }, 3000);
            });
            // this.$emit("toast", "录音时间不得超过60秒");
          }
        };
        this.recorder.start().then(
          () => {
            this.tmpError = {};
            if (Env.isIOS && this.isFirstRecord) {
              this.destroyRecorder();
              this.isFirstRecord = false;
              return;
            }
            console.log("start");
            this.form[key].recording = true;
            this.form[key].showTip = true;
          },
          error => {
            console.log(error);
            let err = "";
            if (/Permission/i.test(error.message)) {
              err = "未开启录音权限";
            } else {
              err = "无法启用录音模块";
              this.form[key].type = "text";
            }
            this.form[key].recording = false;
            this.form[key].showTip = false;
            this.form[key].audio = "";
            console.log(err);
            this.$emit("toast", `录音失败：${err}`);
            this.destroyRecorder();
          }
        );
      }, 250);
    },
    changeMode(target, mode) {
      target.type = mode;
    },
    checkForm() {
      const { form, formItems, errors } = this;
      for (const item of formItems) {
        const val = form[item.key];
        console.log(val, item);
        if (item.type === "question") {
          const checkval =
            val.type === "audio" ? _.get(val, "audio.url") : val.value;
          if (!checkval) {
            return `存在未完成的问题`;
          } else if (errors[item.key]) {
            return "表单项存在错误，请检查";
          }
        } else if (!val) {
          return `请填写${item.label}`;
        }
      }
    },
    onClickItem(key, type) {
      if (type === "date") {
        document.querySelector(`#${key}`).focus();
        document.querySelector(`#${key}`).click();
      }
    },
    async onClickSubmit() {
      if (this.submiting) {
        return;
      }
      this.submiting = true;
      const msg = this.checkForm();
      this.showErr = true;
      if (msg) {
        this.$emit("toast", msg);
        this.$nextTick(() => {
          const target = document.querySelector(".err");
          if (target) {
            target.scrollIntoView();
          }
        });
      } else {
        const { uuid } = this.dataStore.getInfo();
        if (this.isDev) {
          copyText(JSON.stringify({ ...this.submitInfo, uuid }));
          this.$emit("toast", "复制成功");
        }
        try {
          await Apis.saveAnswer({ ...this.submitInfo, uuid });
          this.$emit("next");
        } catch (error) {
          this.$emit("toast", `提交失败：${error.message}`);
        }
      }
      this.submiting = false;
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.step-three {
  padding-bottom: 30px;

  .btn-normal {
    @include px2vw(font-size, 32);
    padding: 0.75em 0;
    width: 95%;
  }
  .main {
    @include px2vw(padding-top, 60);
    @include px2vw(width, 650);
    margin: 0 auto;
    color: #333333;
    text-align: center;
    @include px2vw(font-size, 24);
    @include px2vw(line-height, 33);
  }

  .main-title {
    font-weight: 500;
    @include px2vw(line-height, 50);
    @include px2vw(font-size, 36);
  }
  .sub-title {
    font-weight: 500;
    @include px2vw(line-height, 40);
    @include px2vw(font-size, 28);
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 20);
  }

  .icon {
    &-logo2 {
      margin: 0 auto;
    }
    &-cat {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translateY(100%);
    }
    &-line3 {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translate(50%, 55%);
    }
  }

  .line-wrapper {
    position: relative;
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 195);
      @include px2vw(line-height, 40);
    }
    &-content {
      font-weight: 500;
      text-align: center;
      @include px2vw(line-height, 42);
      @include px2vw(font-size, 30);
      p:first-child {
        @include px2vw(font-size, 34);
        @include px2vw(margin-bottom, 24);
      }
    }
    position: relative;
    background-image: url("~@/assets/img/panel-3.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(padding-top, 90);
    margin: 0 auto;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
  }
}

.form-title {
  flex: 1;
  width: 85%;
  margin: 0 auto;
  @include px2vw(margin-top, 40);
  @include px2vw(margin-bottom, 40);
  @include px2vw(font-size, 32);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 1px;
    background: black;
    position: absolute;
    left: 0;
    top: 50%;
  }
  & span {
    display: inline-block;
    @include px2vw(line-height, 45);
    padding: 0 0.5em;
    background: white;
    position: relative;
    z-index: 2;
  }
}

.form {
  background: white;
  text-align: left;
  .input-inner {
    height: 100%;
    p {
      height: 100%;
    }
    & input {
      position: absolute;
      opacity: 0;
      right: -100px;
      top: -100px;
    }
  }
  .input-wrapper {
    position: relative;
    overflow: hidden;
    flex: 1;
    border-radius: 5px;
    border: 1px solid #979797;
    @include px2vw(line-height, 65);
    @include px2vw(height, 67);
    padding: 0 0.5em;
    display: flex;
    align-items: center;
    & > * {
      flex: 1 0 auto;
    }
    & select,
    & input {
      height: 100%;
      @include px2vw(line-height, 65);
    }
    & select {
      width: 100%;
      height: 100%;
      background: transparent;
      border: none;
      @include px2vw(font-size, 32);
      color: black;
      appearance: none;
      padding: 0;
    }
  }
  &-question,
  &-label {
    @include px2vw(font-size, 28);
    @include px2vw(line-height, 40);
    font-weight: 500;
  }
  &-question {
    margin-top: 20px;
  }
  &-label {
    text-align: right;
    flex-shrink: 0;
    width: 5em;
    margin-right: 0.5em;
    &::after {
      display: inline-block;
      content: "*";
      color: red;
    }
  }
  &-item {
    margin: 10px 0;
    @include px2vw(font-size, 28);
    &--inline {
      display: flex;
      align-items: center;
    }
  }
  &-tip {
    @include px2vw(margin-top, 64);
    @include px2vw(margin-bottom, 40);
    text-align: left;
    font-weight: 500;
    p:first-child {
      margin-bottom: 0.5em;
    }
  }
  & input {
    @include px2vw(height, 64);
    @include px2vw(line-height, 64);
    @include px2vw(font-size, 32);
    padding: 0;
  }
  & input,
  textarea {
    background: none;
    width: 100%;
    border: none;
    appearance: none;
    resize: none;
  }
}

.ques-wrapper {
  position: relative;
  margin-left: 1em;
  border-radius: 5px;
  border: 1px solid #979797;
  padding: 0.5em;
  &.err {
    border-color: red;
  }
  & .err-msg {
    color: red;
  }
  @include px2vw(font-size, 30);
  textarea {
    @include px2vw(font-size, 30);
  }
  &::before {
    display: inline-block;
    content: "*";
    color: red;
    position: absolute;
    left: -1em;
    top: 0;
  }
}

.ques-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
  @include px2vw(font-size, 24);
  user-select: none;
}

.icon-voice {
  display: inline-block;
  vertical-align: bottom;
  background-image: url("~@/assets/img/voice.png");
  @include px2vw(width, 40);
  @include px2vw(height, 40);
  margin-left: 0.75em;
}

.text-btn {
  display: flex;
  align-items: center;
}
.audio-sec {
  @include px2vw(height, 168);
  margin-bottom: 2px;
  position: relative;
}

.record-btn {
  @include px2vw(height, 40);
}

.record-btn-1 {
  color: white;
  background: #9fa6bc;
  display: inline-block;
  @include px2vw(line-height, 40);
  padding: 0 2em;
  border-radius: 3px;
}

.record-btn-2 {
  min-width: 8em;
}

.icon-record1 {
  background-image: url("~@/assets/img/record1.png");
  @include px2vw(width, 442);
  @include px2vw(height, 110);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.icon-record2 {
  background-image: url("~@/assets/img/record2.png");
  @include px2vw(width, 367);
  @include px2vw(height, 48);
  color: white;
  position: relative;
  span {
    position: absolute;
    right: 12%;
    top: 50%;
    transform: translateY(-50%);
  }
}

.record2-wrapper {
  display: flex;
  align-items: center;
}

.icon-del {
  background-image: url("~@/assets/img/del.png");
  @include px2vw(width, 35);
  @include px2vw(height, 35);
  margin-left: 0.5em;
}
</style>
